export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://localhost:7072';
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const MAP_BOX_KEY = import.meta.env.VITE_MAP_BOX_KEY;
